export const adminClubs = {
    namespaced: true,
    state: {
        subscriptionPlans: [],
        countries: [],

        filter: {
            club_id: null,
            name: null,
            description: null,
            country_id: null,
            plan_ids: [],
            sort_column: 'club.creator.data.created_at',
            sort_direction: 'asc'
        },

        pagination: {
            currentPage: 1,
            totalPages: 1,
            totalCount: 0,
            perPage: '50'
        }
    },

    getters: {
        filter(state) {
            return state.filter;
        },

        pagination(state) {
            return state.pagination;
        },

        countries(state) {
            return state.countries;
        },

        subscriptionPlans(state) {
            return state.subscriptionPlans;
        }
    },

    mutations: {
        setFilter(state, data) {
            state.filter = data;
        },

        setCountries(state, data) {
            state.countries = data;
        },

        setSubscriptionPlans(state, data) {
            state.subscriptionPlans = data;
        },

        setPagination(state, data) {
            state.pagination = data;
        },

        setPlans(state, payload) {
            state.filter.plan_ids = payload;
        }
    }
};

export default adminClubs;
